export const sportsData = {
    basketball: {
      label: "Girls Basketball", icon: "🏀",
      tiers: {
        varsity: {
          label: "Varsity",
          seasons: {
            "2025-26": {
              label: "2025–26 Season", teamLabel: "Girls Varsity Basketball", summary: "3-game early season stats", type: "basketball",
              players: [
                {num:"0", name:"Lucy Yoon", gp:1, ppg:2.0, pts:2, fg:0, rpg:2.0, apg:0, spg:5.0, bpg:0, tov:4.0, fpg:4.0},
                {num:"2", name:"Rachel Kim", gp:3, ppg:2.67, pts:8, fg:0, rpg:5.0, apg:0, spg:3.0, bpg:0.33, tov:3.67, fpg:1.33},
                {num:"8", name:"Garam Bae", gp:3, ppg:0.67, pts:2, fg:0, rpg:2.0, apg:0.33, spg:0.33, bpg:0, tov:2.0, fpg:0.33},
                {num:"11", name:"Eunice Lee", gp:1, ppg:0, pts:0, fg:0, rpg:0, apg:0, spg:1.0, bpg:0, tov:1.0, fpg:0},
                {num:"12", name:"Judy Min", gp:2, ppg:2.0, pts:4, fg:0, rpg:1.5, apg:0, spg:0.5, bpg:0, tov:4.5, fpg:0},
                {num:"14", name:"Jade Kim", gp:2, ppg:0, pts:0, fg:0, rpg:2.0, apg:0, spg:0, bpg:0, tov:1.0, fpg:0},
                {num:"19", name:"Jiyu Lim", gp:3, ppg:0, pts:0, fg:0, rpg:7.67, apg:0.67, spg:0.33, bpg:0.33, tov:4.33, fpg:1.33},
                {num:"21", name:"Matilda Kim", gp:2, ppg:3.5, pts:7, fg:0, rpg:7.0, apg:2.0, spg:3.0, bpg:3.5, tov:5.0, fpg:0.5},
                {num:"24", name:"Kendra Poole", gp:3, ppg:6.33, pts:19, fg:0, rpg:3.33, apg:1.0, spg:3.33, bpg:0, tov:7.67, fpg:2.67},
                {num:"26", name:"Junhee Jang", gp:3, ppg:0, pts:0, fg:0, rpg:1.67, apg:0.33, spg:1.0, bpg:0, tov:2.0, fpg:1.67},
                {num:"28", name:"Kyueun Kim", gp:2, ppg:1.0, pts:2, fg:0, rpg:2.0, apg:0, spg:1.5, bpg:0, tov:4.5, fpg:1.5}
              ]
            },
            "2024-25": {
              label: "2024–25 Season", teamLabel: "Girls Varsity Basketball", summary: "27-game season stats", type: "basketball",
              players: [
                {num:"0", name:"Lucy Yoon", gp:27, ppg:2.148, pts:58, fg:38.16, rpg:1.037, apg:0.519, spg:0.963, bpg:0.222, tov:2.259, fpg:1.926},
                {num:"1", name:"Yerim Park", gp:20, ppg:1.25, pts:25, fg:35.71, rpg:0.3, apg:0.4, spg:0.55, bpg:0.05, tov:1.1, fpg:0.3},
                {num:"2", name:"Rachel Kim", gp:22, ppg:0.864, pts:19, fg:30.43, rpg:1.091, apg:0.182, spg:0.5, bpg:0.045, tov:1.182, fpg:1.591},
                {num:"8", name:"Garam Bae", gp:23, ppg:0.304, pts:7, fg:15.79, rpg:1.304, apg:0.13, spg:0.261, bpg:0.043, tov:0.304, fpg:0.087},
                {num:"9", name:"Rachel In", gp:18, ppg:0.778, pts:14, fg:11.90, rpg:2, apg:0.389, spg:2.111, bpg:0.056, tov:1.944, fpg:1.111},
                {num:"12", name:"Judy Min", gp:19, ppg:1.474, pts:28, fg:54.17, rpg:0.684, apg:0.263, spg:0.211, bpg:0, tov:0.895, fpg:0.158},
                {num:"14", name:"Jiwoo Kim", gp:25, ppg:0.64, pts:16, fg:21.43, rpg:0.88, apg:0.04, spg:0.32, bpg:0, tov:0.84, fpg:0.24},
                {num:"19", name:"Jiyu Lim", gp:27, ppg:1.407, pts:38, fg:22.22, rpg:2.407, apg:0.259, spg:0.63, bpg:0.185, tov:1.111, fpg:0.667},
                {num:"21", name:"Matilda Kim", gp:26, ppg:6.385, pts:166, fg:42.20, rpg:2.923, apg:1.154, spg:1.077, bpg:1.154, tov:3.192, fpg:0.923},
                {num:"24", name:"Kendra Poole", gp:17, ppg:3.412, pts:58, fg:25.56, rpg:1.588, apg:0.647, spg:2.118, bpg:0.059, tov:2.588, fpg:1.353},
                {num:"33", name:"Haram Yoo", gp:19, ppg:1.316, pts:25, fg:29.41, rpg:3.895, apg:0.158, spg:0.842, bpg:0.263, tov:1.105, fpg:1.105}
              ]
            }
          }
        },
        jv: {
          label: "JV",
          seasons: {
            "2025-26": {
              label: "2025–26 Season", teamLabel: "Girls JV Basketball", summary: "SJA vs NLCS single-game stats", type: "basketball-jv",
              players: [
                {num:"5", name:"Daeun Son", pts:0, reb:0, ast:0, stl:1, blk:0, tov:0, foul:0},
                {num:"7", name:"Hayoon Park", pts:2, reb:2, ast:1, stl:1, blk:0, tov:0, foul:0},
                {num:"17", name:"Isabella Lee", pts:4, reb:0, ast:0, stl:0, blk:0, tov:0, foul:1},
                {num:"23", name:"Jiwon Kim", pts:8, reb:3, ast:0, stl:0, blk:0, tov:0, foul:1},
                {num:"30", name:"Sena Min", pts:8, reb:2, ast:1, stl:0, blk:0, tov:0, foul:1},
                {num:"36", name:"Leina Lee", pts:0, reb:0, ast:0, stl:0, blk:0, tov:0, foul:0},
                {num:"45", name:"Yejin Ahn", pts:4, reb:1, ast:1, stl:0, blk:0, tov:0, foul:0}
              ]
            }
          }
        }
      }
    },
    basketballBoys: {
      label: "Boys Basketball", icon: "🏀",
      tiers: {
        varsity: {
          label: "Varsity",
          seasons: {
            "2024-25": {
              label: "2024–25 Season", teamLabel: "Boys Varsity Basketball", summary: "23-game season stats", type: "basketball",
              players: [
                {num:"5", name:"Minjun Kim", gp:23, ppg:6.65, pts:153, fg:44.97, rpg:4.87, apg:4.17, spg:2.78, bpg:0.57, tov:2.04, fpg:0.52},
                {num:"13", name:"Harry Lyoo", gp:19, ppg:2.79, pts:53, fg:36.92, rpg:2.00, apg:0.37, spg:1.00, bpg:0.26, tov:1.11, fpg:0.53},
                {num:"14", name:"Wonjun Son", gp:21, ppg:1.14, pts:24, fg:20.00, rpg:1.43, apg:1.10, spg:0.62, bpg:0.00, tov:1.05, fpg:0.57},
                {num:"15", name:"Liam Bhu", gp:18, ppg:5.28, pts:95, fg:30.43, rpg:2.11, apg:0.78, spg:1.39, bpg:0.17, tov:1.50, fpg:0.94},
                {num:"21", name:"Jiamu Yue", gp:22, ppg:8.18, pts:180, fg:33.64, rpg:3.00, apg:1.50, spg:2.36, bpg:0.00, tov:2.14, fpg:1.45},
                {num:"22", name:"Juho Yang", gp:19, ppg:9.16, pts:174, fg:37.02, rpg:3.32, apg:2.11, spg:1.84, bpg:0.11, tov:2.42, fpg:1.21},
                {num:"28", name:"Leo Kim", gp:15, ppg:5.80, pts:87, fg:35.29, rpg:4.13, apg:1.07, spg:1.33, bpg:0.53, tov:1.13, fpg:0.27},
                {num:"30", name:"Juhyun Kim", gp:23, ppg:7.00, pts:161, fg:48.15, rpg:4.96, apg:0.83, spg:1.00, bpg:0.43, tov:1.78, fpg:0.35},
                {num:"32", name:"Tiger Jin", gp:20, ppg:2.75, pts:55, fg:40.00, rpg:1.15, apg:1.25, spg:0.65, bpg:0.05, tov:1.70, fpg:0.65},
                {num:"34", name:"Woongjay Shin", gp:8, ppg:3.75, pts:30, fg:40.00, rpg:2.00, apg:0.88, spg:0.50, bpg:0.38, tov:1.13, fpg:0.38},
                {num:"41", name:"Harry Jin", gp:23, ppg:5.96, pts:137, fg:58.82, rpg:3.43, apg:1.17, spg:1.39, bpg:0.00, tov:1.43, fpg:1.13},
                {num:"51", name:"Taehyun Kwon", gp:22, ppg:2.91, pts:64, fg:49.21, rpg:3.23, apg:0.36, spg:0.73, bpg:0.09, tov:0.91, fpg:0.41}
              ]
            }
          }
        }
      }
    },
    volleyball: {
      label: "Boys Volleyball", icon: "🏐",
      tiers: {
        varsity: {
          label: "Varsity",
          seasons: {
            "2025": {
              label: "2025 Season", teamLabel: "Boys Varsity Volleyball", summary: "Season totals", type: "volleyball",
              players: [
                {num:"2", name:"Jueon Kang", aces:11, digs:5, blocks:7, spikes:8},
                {num:"4", name:"Changbin Yoon", aces:2, digs:64, blocks:0, spikes:0},
                {num:"5", name:"Minjae Lee", aces:9, digs:9, blocks:1, spikes:16},
                {num:"9", name:"Yul Cho", aces:18, digs:20, blocks:5, spikes:1},
                {num:"10", name:"Hyunjun Jang", aces:1, digs:12, blocks:0, spikes:0},
                {num:"13", name:"Yongseon Kim", aces:26, digs:31, blocks:3, spikes:53},
                {num:"14", name:"Taehun Lyoo", aces:8, digs:2, blocks:5, spikes:1},
                {num:"18", name:"Heejun Kim", aces:7, digs:3, blocks:5, spikes:7},
                {num:"21", name:"Soonbum Kwon", aces:10, digs:9, blocks:14, spikes:42},
                {num:"23", name:"Doyoon Kim", aces:22, digs:12, blocks:7, spikes:36},
                {num:"26", name:"Juhan Yoo", aces:21, digs:36, blocks:4, spikes:88},
                {num:"42", name:"Seokjun Go", aces:14, digs:12, blocks:16, spikes:26}
              ]
            }
          }
        }
      }
    },
    lacrosse: {
      label: "Boys Lacrosse", icon: "🥍",
      tiers: {
        varsity: {
          label: "Varsity",
          seasons: {
            "2025": {
              label: "Fall 2025", teamLabel: "Boys Varsity Lacrosse", summary: "5-game fall season", type: "lacrosse",
              players: [
                {name:"Sewon Lee", goals:5, assists:0, gbs:5, ct:1, role:"Defense"},
                {name:"Jinho Han", goals:4, assists:1, gbs:2, ct:0, role:"Midfield"},
                {name:"Jinhyuk Yang", goals:3, assists:0, gbs:2, ct:1, role:"Midfield"},
                {name:"Junyoung Kim", goals:2, assists:1, gbs:3, ct:0, role:"Midfield"},
                {name:"Dongjun Park", goals:1, assists:1, gbs:10, ct:2, role:"Midfield"},
                {name:"Yunyeol Choi", goals:1, assists:0, gbs:4, ct:0, role:"Midfield"},
                {name:"Junyoung Lee", goals:1, assists:0, gbs:2, ct:0, role:"Midfield"},
                {name:"Seojun Lee", goals:1, assists:0, gbs:0, ct:0, role:"Midfield"},
                {name:"Seokwon Jeong", goals:0, assists:0, gbs:6, ct:2, role:"Defense"},
                {name:"Hyunbin Kim", goals:0, assists:0, gbs:1, ct:3, role:"Defense"},
                {name:"Choonghee Lee", goals:0, assists:0, gbs:1, ct:1, role:"Goalie"},
                {name:"Doyoung Yu", goals:0, assists:0, gbs:3, ct:0, role:"Midfield"},
                {name:"Yanyu Bai", goals:0, assists:1, gbs:0, ct:0, role:"Midfield"},
                {name:"Jemin Choi", goals:0, assists:0, gbs:1, ct:0, role:"Defense"},
                {name:"Minseo Kwon", goals:0, assists:0, gbs:1, ct:0, role:"Midfield"}
              ]
            }
          }
        }
      }
    }
  };